import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { helpersPropTypes } from '~helpers';
import { typographyPropTypes } from '~typography';
import { DefaultTemplate } from '~template';
import SiteLaunch from './SiteLaunch';
import siteLaunchPropTypes from '../prop-types/siteLaunchPropTypes';
import siteLaunchTheme from '../styles/siteLaunchTheme';

var SiteLaunchTemplate = function SiteLaunchTemplate(_ref) {
  var logoPath = _ref.logoPath,
      logoPathAlt = _ref.logoPathAlt,
      title = _ref.title,
      customTitle = _ref.customTitle,
      subtitle = _ref.subtitle,
      callToActions = _ref.callToActions,
      customBg = _ref.customBg,
      footer = _ref.footer,
      viewportHeight = _ref.viewportHeight,
      transitionType = _ref.transitionType,
      transitionTimeout = _ref.transitionTimeout,
      content = _ref.content,
      valuePropositionColor = _ref.valuePropositionColor,
      transitionOnEntered = _ref.transitionOnEntered,
      aside = _ref.aside,
      alert = _ref.alert,
      alignMainItems = _ref.alignMainItems;
  var theme = useContext(ThemeContext);

  var bgStart = _get(theme, 'siteLaunch.bgStart', siteLaunchTheme.siteLaunch.bgStart);

  var bgEnd = _get(theme, 'siteLaunch.bgEnd', siteLaunchTheme.siteLaunch.bgEnd);

  return /*#__PURE__*/React.createElement(DefaultTemplate, {
    bgStart: bgStart,
    bgEnd: bgEnd,
    customBg: customBg,
    footer: footer,
    main: /*#__PURE__*/React.createElement(React.Fragment, null, alert, /*#__PURE__*/React.createElement(SiteLaunch, {
      logoPath: logoPath,
      logoPathAlt: logoPathAlt,
      title: title,
      customTitle: customTitle,
      subtitle: subtitle,
      callToActions: callToActions,
      viewportHeight: viewportHeight,
      transitionType: transitionType,
      transitionTimeout: transitionTimeout,
      valuePropositionColor: valuePropositionColor,
      transitionOnEntered: transitionOnEntered,
      aside: aside,
      alignItems: alignMainItems
    })),
    content: content
  });
};

SiteLaunchTemplate.defaultProps = {
  logoPath: undefined,
  logoPathAlt: undefined,
  title: undefined,
  customTitle: undefined,
  subtitle: undefined,
  callToActions: undefined,
  customBg: undefined,
  footer: undefined,
  viewportHeight: undefined,
  transitionType: undefined,
  transitionTimeout: undefined,
  content: undefined,
  valuePropositionColor: undefined,
  transitionOnEntered: function transitionOnEntered() {},
  aside: undefined,
  alert: undefined,
  alignMainItems: undefined
};
export default SiteLaunchTemplate;